module.exports = __webpack_public_path__ + "static/feature1-1695b993335332299490150ff1a54ee0.jpg";